import React from 'react'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoLogo from 'EurestoStyle/font/euresto_01.png'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {

  state= {
    data: []
  }

  async componentDidMount () {

    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'login',
      email: 'technique@euresto.com',
      password: 'euresto2012'
    }, { showAlertError: false })
    const request = await ApiRequest(project.api + 'crm', {
      token: result.token,
      requete: 'client',
      action: 'list',
      coordonnees: true,
      recherche: [ {"champ": "licence_active", "valeur": [undefined, 1], "operation": "egal"},
        {"champ": "email", "valeur": [undefined, ''], "operation": "egal", non: true},
        {"champ": "exclusEmailing", "valeur": 0, "operation": "egal"},
        {"champ":"qualite_id","valeur":[1,22,23,24,25,26,3,4],"operation":"contain"}]
    })
    this.setState({
      data: request.results.filter(contact => contact.email || (contact.coordonnees && contact.coordonnees.length > 0 && (contact.coordonnees.filter(cs => cs.type === 1 && cs.libelle === "Email Export").length > 0)))
        .map(c => ({
          id: c.id,
          email: c.coordonnees && (c.coordonnees.length > 0 && c.coordonnees.filter(cs => cs.type === 1 && cs.libelle === "Email Export").length > 0 && c.coordonnees.filter(cs => cs.type === 1 && cs.libelle === "Email Export")[0].valeur) || c.email,
          key: c.key_contact
        }))
    })
  }

  render () {
    return (
      <Grid container spacing={0} style={{margin: 0, padding: 0, top: 0, color: '#393939', fontSize: 15, maxHeight: '100vh', overflow: 'auto'}} justify={'center'} alignItems={'center'}>

        <Grid xs={12} style={{margin: 0, padding: 10}}><img style={{ maxWidth: 'calc(100vw  - 20px )' }} width="400" src={EurestoLogo}/></Grid>

        <Grid xs={12} style={{margin: 0, padding: 10}}>{this.state.data && this.state.data.length}</Grid>
        {
          this.state.data.map((c, i) => (
            <Grid xs={12} item style={{margin: 0, padding: 10, background: i%2 && '#F9F9F9' || '#D9D9D9'}}>
              {c.libelle}<br/>
              {c.email}<br/>
            </Grid>
          ))
        }
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/Emailing2019/index.js